export const formatCurrency = value => {
  if (typeof value !== 'number') value = parseFloat(value);
  if (isNaN(value)) return '-';
  return new Intl.NumberFormat('en-US', { currency: 'USD', style: 'currency' }).format(value);
};

export const getDueDateStatus = (dueDate, paid, t) => {
  if (!dueDate || paid)
    return {
      color: paid ? 'success' : 'default',
      text: paid ? t('invoices.filters.paid') : t('invoices.filters.unpaid')
    };
  const due = new Date(dueDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);
  const diff = due.getTime() - today.getTime();
  const dayDiff = Math.ceil(diff / (1000 * 3600 * 24));
  if (dayDiff < 0) return { color: 'error', text: t('invoices.status.overdue') };
  if (dayDiff === 0) return { color: 'warning', text: t('invoices.status.dueToday') };
  if (dayDiff < 3) return { color: 'warning', text: t('invoices.status.dueSoon') };
  return { color: 'default', text: t('invoices.filters.unpaid') };
};
